
import '../BeanButton.css'

function BeanButtonPrev({ onClick, expanded }) {
    return (
        <div className={(expanded == null ? 'bean-button-full-circle-dynamic' : expanded == true ? 'bean-button-half-circle' : 'bean-button-full-circle')
            + ' flex align_center justify_center cursor_pointer'} onClick={onClick}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M11 15L5 9L11 3" stroke="url(#paint0_linear_1_2093)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <defs>
                    <linearGradient id="paint0_linear_1_2093" x1="14" y1="11.625" x2="10.7448" y2="1.13302" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#235539" />
                        <stop offset="1" stopColor="#7B946B" />
                    </linearGradient>
                </defs>
            </svg>
        </div>


    )
};

export default BeanButtonPrev;

